import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { GetForeignFilters } from '../graphql/queries'
import SearchIcon from './icons/search'
import Input from './Input'
import SelectInput from './SelectInput'

const initialState = {
    query: null,
    year: null,
}

const initialOptions = {
    years: [],
}

const ForeignFilters = forwardRef(({
    onFilterChange,
    allow,
}, ref) => {

    const { t } = useTranslation()
    const [filterOptions, setFilterOptions] = useState(initialOptions)
    const [filters, setFilters] = useState(initialState)

    const { refetch } = useQuery(GetForeignFilters, {
        onCompleted: (data) => {
            if (data?.getForeignFilters?.years) {
                const yearList = data.getForeignFilters.years.map(x => ({
                    value: x,
                    label: x,
                }))

                setFilterOptions({
                    ...filterOptions,
                    years: yearList,
                })
            }
        },
    })

    useEffect(() => {
        if (onFilterChange) onFilterChange(filters)
    }, [])

    useImperativeHandle(ref, () => ({
        refresh () {
            refetch()
        },
    }))

    const setField = (field, value) => {
        const newVal = {
            ...filters,
            [field]: value,
        }

        setFilters(newVal)

        if (onFilterChange) onFilterChange(newVal)
    }

    return (
        <div className='filters filters-foreign'>
            {
                allow?.search ?
                <div className='filters-search'>
                    <Input
                        placeholder={ t('foreign.search') }
                        onChange={(e) => setField('query', e.target.value)}
                        value={filters.query}
                        icon={<SearchIcon />}
                    />
                </div>
                :
                <></>
            }
            {
                allow?.year ?
                <SelectInput
                    options={filterOptions.years}
                    onChange={(option) => setField('year', option ? parseInt(option.value) : null)}
                    value={filterOptions.years.find(x => parseInt(x.value) === filters.year)}
                    placeholder={t('filters.year')}
                    isClearable={true}
                />
                :
                <></>
            }
        </div>
    )
})

export default ForeignFilters